import { PendingApprovalJob } from '@app/models/job.model';

export interface PendingApprovalSummary {
  readonly siteId: string;
  readonly siteName: string | null;
  readonly brandName: string | null;
  readonly reactive: number;
  readonly ppm: number;
}

export function summarizePendingApprovalJobs(
  jobs: readonly PendingApprovalJob[]
): PendingApprovalSummary[] {
  const summaries = new Map<string, {
    siteId: string;
    siteName: string | null;
    brandName: string | null;
    reactive: number;
    ppm: number;
  }>();

  for (const job of jobs) {
    const jobType = job.jobType?.toUpperCase();
    if (jobType !== 'REACTIVE' && jobType !== 'PPM') {
      continue;
    }

    const siteKey = job.siteId.toLowerCase();
    let summary = summaries.get(siteKey);
    if (!summary) {
      summary = {
        siteId: job.siteId,
        siteName: job.site?.name ?? null,
        brandName: job.site?.brand?.name ?? null,
        reactive: 0,
        ppm: 0
      };
      summaries.set(siteKey, summary);
    }

    if (jobType === 'PPM') {
      summary.ppm += 1;
    } else {
      summary.reactive += 1;
    }
  }

  return [...summaries.values()].sort(
    (left, right) => (left.siteName ?? '').localeCompare(right.siteName ?? '')
  );
}
